module.exports = __webpack_public_path__ + "img/iconoestilo.38504f0e.svg";